var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBear = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 434,
    height: 443,
    xmlns: "http://www.w3.org/2000/svg",
    className: "hero-bear",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "70.624%",
    y1: "3.197%",
    x2: "25.016%",
    y2: "110.442%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D89868",
    offset: "41.92%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE8E5F",
    offset: "68.15%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68659",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "87.721%",
    y1: "7.18%",
    x2: "11.625%",
    y2: "109.001%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D89868",
    offset: "41.92%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE8E5F",
    offset: "68.15%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68659",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-45.202%",
    y1: "50.07%",
    x2: "145.198%",
    y2: "50.07%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D89868",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68659",
    offset: "96.77%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "3.363%",
    y1: "61.763%",
    x2: "98.962%",
    y2: "25.996%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68659",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68659",
    offset: "83.04%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68659",
    offset: "96.77%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.632%",
    y1: "85.637%",
    x2: "101.847%",
    y2: "20.444%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68659",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68659",
    offset: "83.04%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68659",
    offset: "96.77%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.643%",
    y1: "71.2%",
    x2: "53.617%",
    y2: "33.894%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D89868",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C68659",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "93.211%",
    y1: "6.295%",
    x2: "46.909%",
    y2: "53.168%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 434 0)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "#325187"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.6 96.7l-1.5 14.9c-.4 3.8 2.9 7 6.7 6.4 3.8-.6 6-4.6 4.5-8.1l-5.9-13.7c-.9-1.9-3.6-1.5-3.8.5zM414.9 98.3l-7.6 6.9c-1.9 1.8-1.7 4.9.5 6.3 2.2 1.4 5.1.4 6-2.1l3.2-9.7c.5-1.3-1.1-2.3-2.1-1.4zM425.4 109.2l-9 4.7c-2.3 1.2-2.9 4.3-1.1 6.2 1.8 1.9 4.9 1.7 6.3-.5l5.6-8.5c.6-1.2-.6-2.6-1.8-1.9zM431.4 123l-9.7 3c-2.5.8-3.6 3.7-2.2 5.9s4.5 2.5 6.3.6l7-7.4c.9-.9-.1-2.5-1.4-2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.2 208.2c-.5 3.1.1 3.2-.4 6.3l-1 6.2-.2.2c-2-.9-3.5-2.6-5.2-4-1.7-1.4-3.5-2.6-4.8-4.3-1.3-1.7-2.1-3.8-2.9-5.8-.1-.1-.3 0-.3-.2",
    fill: "#D19161",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9 211.7c-.1 4.2.4 4.2.3 8.4l-.2.1c-2.1-.7-4.1-1.7-5.8-3.1-1.7-1.4-2.6-3.4-3.7-5.4 0-.1-.5.2-.6.1",
    fill: "#D19161",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 308.9h-98.6c-26.6 0-48.2-21.6-48.2-48.2V128.6c0-18.8 15.2-34 34-34H235c15.6 0 28.3 12.7 28.3 28.3v157.7c-.1 15.7-12.7 28.3-28.3 28.3z",
    fill: "#DBE1EE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#649EF7",
    fillRule: "nonzero",
    opacity: 0.2,
    cx: 96,
    cy: 141,
    rx: 4.7,
    ry: 6
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    stroke: "#649EF7",
    strokeWidth: 2,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.7 241.8h-7.3M100.7 252.7h-7.3M100.7 263.5h-7.3M100.7 258.1h-7.3M100.7 247.2h-7.3"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#649EF7",
    fillRule: "nonzero",
    opacity: 0.2,
    d: "M97.1 156.6h2.4v3.3h-2.4zM92.4 150.6h2.4v3.3h-2.4z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#D29263"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.3 369.8c2.7 1.6 3 1.1 5.7 2.7s2.7 1.7 5.3 3.2h-.3c.5-2.1 1.3-4.2 1.3-6.4s-.8-4.3-1.4-6.4c-.5-2.1-1.1-4.2-2.1-6.1-.1-.1-.3 0-.3-.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.1 361.4c4.1.6 4.2 0 8.4.6l-.1.2c-.3-2.2-1.2-4.1-2.3-6-1.1-1.9-2.1-3.9-3.8-5.3-.1-.1-.4.4-.5.3M298.4 376.1c3 2.9 3.4 2.5 6.5 5.3l-.2.1c1-2 1.4-4.1 1.6-6.2.2-2.1.6-4.4 0-6.5 0-.1-.5.1-.6 0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.8 23.3l5.7 16.2 3.4 9.5c.6 2 1.2 3.9 1.7 5.9.5 2 1 4 1.4 6 1.6 8 2.3 16.1 2.1 24.2-.3 8.1-1.5 16-3.6 23.6-4.2 15.3-11.8 29.3-22.2 40.8-10.2 11.5-23.2 20.3-37.1 25.8l10.7-10.4L48 171c-7.5 9.3-21.1 10.8-30.5 3.3-6.9-5.5-9.5-14.4-7.4-22.4l2-7.6c.8-2.9 2.5-5.2 4.9-6.7l5.9-3.7c6.7-4.3 12.2-9.8 16-16.3 3.8-6.4 6-13.6 6.5-20.6.2-3.5 0-7-.5-10.3-.6-3.3-1.6-6.5-2.9-9.5-.3-.8-.7-1.5-1-2.2l-1.2-2.1-.6-1-.3-.5-.5-.8-2.1-3.7-8.4-15c-9.3-16.7-3.3-37.8 13.4-47.1C58-4.5 79.1 1.5 88.4 18.2c.9 1.4 1.7 3.3 2.4 5.1z",
    fill: "url(#a)",
    transform: "translate(208 251)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#325187"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.3 424.9l5.9-9c1.5-2.3 4.8-2.6 6.7-.5 1.9 2.1 1.3 5.3-1.2 6.6l-9.6 5c-1.3.6-2.6-.9-1.8-2.1zM220.5 435.3l5-9.6c1.3-2.5 4.5-3.1 6.6-1.2 2.1 1.9 1.8 5.2-.5 6.7l-9 6c-1.3.8-2.8-.6-2.1-1.9zM236.9 440.7l1.9-10.6c.5-2.7 3.4-4.3 6-3.1 2.5 1.2 3.2 4.4 1.5 6.5l-6.9 8.3c-.9 1.2-2.7.3-2.5-1.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.3 32.9l1.3 17.9.6 9 .1 1.1.2 1.5.4 3.1.6 6.3c.5 8.4 0 16.8-1.5 24.9-1.5 8.2-4 16.1-7.4 23.5-3.4 7.4-7.6 14.4-12.6 20.7-5 6.3-10.7 12-17 16.9-6.3 4.9-13.1 9-20.3 12.2-7.2 3.2-14.7 5.4-22.3 6.8l12.7-8.3-4.3 4.2c-8.5 8.5-22.3 8.4-30.7-.1-7-7-8.1-17.6-3.6-25.8l2.9-5.3c1.7-3.1 4.5-5.3 7.6-6.4l5.1-1.8c3.9-1.4 7.6-3.3 11-5.5 3.4-2.2 6.4-4.9 9.1-7.7 2.7-2.9 4.9-6.1 6.8-9.5 1.8-3.4 3.2-7 4.2-10.5.9-3.6 1.4-7.3 1.4-10.9 0-3.6-.4-7.1-1.2-10.6-.2-.9-.5-1.7-.7-2.5l-.4-1.3-.2-.6-.4-1.1-3.2-8.4L50 48C43 29.7 52.2 9.3 70.5 2.4c18.3-6.9 38.7 2.2 45.6 20.5 1.3 3.2 2 6.7 2.2 10z",
    fill: "url(#b)",
    transform: "translate(82 227)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#325187"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.8 394.2l7.8-7.9c2-2 5.4-1.6 6.9.8 1.5 2.5.2 5.6-2.5 6.4l-10.7 3.1c-1.5.5-2.6-1.3-1.5-2.4zM91 408.1l6.5-9.1c1.7-2.3 5.1-2.4 6.9-.2 1.8 2.2 1.1 5.5-1.5 6.8l-10.1 4.7c-1.3.6-2.7-1-1.8-2.2zM105.8 415.9l5.1-9.9c1.3-2.5 4.7-3.2 6.8-1.2 2.1 1.9 1.9 5.3-.5 6.9l-9.3 6.1c-1.3.8-2.8-.6-2.1-1.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M284.4 308.9H155.1c-26.6 0-48.2-21.6-48.2-48.2V128.6c0-18.8 15.2-34 34-34h143.6c15.6 0 28.3 12.7 28.3 28.3v157.7c-.1 15.7-12.8 28.3-28.4 28.3z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D89868",
    fillRule: "nonzero",
    d: "M163.9 302.8l-2.2 7.2-5.1 5.5-7.3.7-6.7-1.7-5.3-4.7-3-7 3.1-6.8 4.3-6.5 7.6-2 7.6 2.2 5.3 5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#c)",
    strokeWidth: 26,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M217.6 310.8l-12.7 12.6h-16"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "#325187"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5 137.5l1.5 14.9c.4 3.8-2.9 7-6.7 6.4-3.8-.6-6-4.6-4.5-8.1l5.9-13.7c.8-1.9 3.5-1.5 3.8.5zM17.2 143.1l7.6 6.9c1.9 1.8 1.7 4.9-.5 6.3-2.2 1.4-5.1.4-6-2.1l-3.2-9.7c-.5-1.2 1-2.3 2.1-1.4zM6.7 154l9 4.7c2.3 1.2 2.9 4.3 1.1 6.2-1.8 1.9-4.9 1.7-6.3-.5l-5.6-8.5c-.7-1.2.6-2.5 1.8-1.9zM2.6 168.8l9.7 3c2.5.8 3.6 3.7 2.2 5.9s-4.5 2.5-6.3.6l-7-7.4c-.9-.9.1-2.5 1.4-2.1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7394DB",
    fillRule: "nonzero",
    d: "M368.054 133.69l3.37-3.131 3.131 3.369-3.37 3.132z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.2 99.4l33.5 23.9 4.2 3 2.1 1.5c.3.2.7.5 1 .7l.8.5c2.1 1.4 4.3 2.5 6.5 3.6 2.2 1 4.5 1.9 6.8 2.6 2.3.7 4.6 1.2 7 1.6 9.4 1.4 19 .1 27.3-3.6 8.3-3.6 15.1-9.5 20-16.6 8.7-12.9 26.2-16.2 39.1-7.5 12.9 8.7 16.2 26.2 7.5 39.1-.8 1.2-1.7 2.3-2.6 3.3l-1.1 1.1c-6.4 6.9-13.7 13-21.8 17.8-2 1.3-4.1 2.3-6.1 3.4-2.1 1-4.2 2.1-6.3 3-4.3 1.9-8.7 3.4-13.1 4.5-17.8 4.8-36.6 4.5-53.8-.7-4.3-1.3-8.5-2.9-12.5-4.8s-7.9-4-11.6-6.5c-3.7-2.4-7.2-5-10.5-7.9l-1.2-1.1c-.4-.4-.7-.6-1-.9l-1.9-1.8-3.8-3.5-30.2-28.1c-7-6.5-7.3-17.4-.9-24.4 6-6.3 15.7-7.2 22.6-2.2z",
    fill: "url(#d)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#649EF7",
    fillRule: "nonzero",
    opacity: 0.2,
    cx: 121.7,
    cy: 228.3,
    r: 11.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.5 134.2l-23.9 34.2-3 4.3-1.5 2.1-.7 1.1c-.3.4-.5.7-.8 1.2-2.6 3.6-5.5 7-8.6 10.2-6.3 6.4-13.5 12-21.4 16.4-15.8 8.9-34.4 13.2-53 12.1-2.3-.1-4.6-.4-7-.6-2.3-.4-4.6-.7-6.9-1.2-4.6-.9-9.2-2.2-13.6-3.8-8.9-3.2-17.4-7.8-25.1-13.4l-1-.7c-12.3-8.9-15-26.1-6.1-38.4 8.9-12.3 26.1-15 38.4-6.1 1 .8 2.1 1.7 3 2.6 6.3 6.1 14.4 10.5 23.5 12.3 9 1.8 18.9 1 27.9-2.6 4.5-1.8 8.8-4.2 12.7-7.3 1.9-1.5 3.8-3.2 5.5-5.1.2-.2.5-.5.8-.9l.9-1 1.7-1.9 3.5-3.9 27.9-31.1c6.4-7.1 17.3-7.7 24.3-1.3 6.4 6 7.4 15.7 2.5 22.8z",
    fill: "url(#e)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.6 220.8c15.7 63.8-31.2 126.6-96.8 128.2h-2.7c-57.5 0-94.3-45.7-96.1-102.8-.1-2.1.1-4.1.5-6.1l8.3-78.3c6-39.4 38-69.6 77.6-73.5 45.5-4.4 86.8 27.1 94.4 72.2l14.8 60.3z",
    fill: "url(#f)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDCCA2",
    fillRule: "nonzero",
    opacity: 0.3,
    cx: 37.3,
    cy: 173,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.4 202c3.1-.1 3.1-.7 6.2-.8l6.2-.2-.2.1c-.7-2.1-1.2-4.3-2.4-6.1-1.2-1.8-3-3.1-4.6-4.6-1.6-1.5-3.2-3-5.1-4-.1-.1-.2.1-.4.1",
    fill: "#C8885B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.1 210c4.2.3 4.2-.3 8.4 0l-.1.2c-.5-2.1-1.5-4.1-2.7-5.8-1.2-1.7-2.4-3.8-4.2-5-.1-.1-.4.4-.5.3",
    fill: "#CB8B5E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.8 222.6c-.8-3.4-.5-3.5-1.3-6.8-.8-3.4-1-3.3-1.8-6.7-.8-3.4-.7-3.4-1.5-6.8s-.5-3.5-1.3-6.9c-.8-3.4-1.2-3.3-2.1-6.7-.8-3.4-1.1-3.3-1.9-6.7-.8-3.4-.9-3.4-1.7-6.7-.8-3.4-.2-3.5-1-6.9l-1.6-6.8c-.1-.4-.1-.3-.2-.7-.4-2.4-1-4.8-1.6-7.1-.7-2.3-1.6-4.6-2.5-6.8-.9-2.3-1.5-4.7-2.6-6.8-1.1-2.1-2.8-4-4.2-6-1.4-2-3.2-3.6-4.7-5.5-1.6-1.8-2.8-4-4.6-5.6-1.8-1.7-3.5-3.3-5.5-4.8-1.9-1.5-3.9-2.9-6-4.1-2.1-1.2-4.2-2.4-6.4-3.4s-4.7-1.3-7-2c-2.3-.8-4.6-1.4-6.9-1.9-2.3-.5-4.7-.8-7.1-1-2.4-.3-4.7-.4-7.2-.4-2.2 0-4.4-.6-6.6-.4-2.5.2-4.8 1-7.2 1.5-2.4.5-4.8 1.1-7.1 1.8-2.3.8-4.8 1.2-7 2.2-2.2 1-4.3 2.5-6.4 3.7-2.1 1.3-4.2 2.5-6.2 4s-4 3-5.8 4.6c-1.8 1.7-3.3 3.7-4.9 5.5-1.6 1.9-3.2 3.8-4.6 5.8-1.4 2-2.3 4.3-3.5 6.5-1.1 2.2-2.4 4.3-3.3 6.6-.9 2.3-2 4.5-2.7 6.9-.6 2.3-.6 4.9-1 7.3-.4 3.4-.2 3.5-.5 6.9-.4 3.5-1 3.4-1.4 6.8-.4 3.5-.2 3.5-.6 6.9-.4 3.5-.4 3.4-.8 6.9-.4 3.5 0 3.5-.4 6.9-.4 3.5 0 3.5-.4 6.9-.4 3.5-.3 3.5-.7 6.9-.4 3.5-1.2 3.4-1.6 6.8-.4 3.5 0 3.5-.4 6.9-.4 3.5.2 3.5-.2 7s.2 3.7-.8 7c-1.9 1.7-3.4 3.9-4.4 6.3l-.4.1c1.8.2 2.1-.9 3.4.4-1.2 2-2.2 3.9-2.9 6.2-.6 2.3-.8 5.1-.8 7.5 2.7.4 2.8-3.2 5.4-2.4-.8 2.8-1 6.2-.4 9.1.8.6.8-1.4 1.7-.9.5 2.4 1.6 4.6 2.3 6.9.7 2.4 1.1 4.8 2 7.1.9 2.3 2.4 4.3 3.5 6.5s2 4.5 3.3 6.5c1.3 2.1 2.1 4.5 3.5 6.5 1.5 2 3.6 3.4 5.3 5.2 1.7 1.9 3.5 3.6 5.4 5.3 1.9 1.7 3.5 3.6 5.6 5.1 2.1 1.5 4.4 2.4 6.6 3.7 2.2 1.2 4.1 3.1 6.4 4.1 2.3 1 4.9 1.4 7.3 2.2 2.4.7 4.9 1 7.4 1.5s4.9 1.4 7.4 1.6c2.5.2 5 0 7.6 0 .7 0 1.4-.1 2.2-.1 2.5-.1 4.9.3 7.3 0 2.4-.3 4.9-.6 7.3-1.1 2.4-.5 4.7-1.3 7.1-2 2.3-.7 4.5-1.8 6.8-2.7 2.3-.9 4.4-2.1 6.6-3.2 2.2-1.1 4.6-1.7 6.7-3 2.1-1.3 3.9-2.9 5.8-4.4 1.9-1.5 3.5-3.3 5.3-5 1.8-1.6 4-2.9 5.7-4.7 1.6-1.8 2.8-4 4.3-6s3.4-3.8 4.8-5.9c1.3-2.1 2.1-4.6 3.2-6.8 1.2-2.2 2.2-4.5 3.2-6.8.9-2.3 1.7-4.7 2.4-7.1.7-2.4 1.7-4.7 2.2-7.2.5-2.5.6-5 .9-7.5.3-2.5 1.1-4.9 1.2-7.5.1-2.5-.7-5-.9-7.5-.2-2.5-.3-5-.7-7.5-.6-2.4-1.2-4.8-1.8-7.3z",
    opacity: 0.3,
    fillRule: "nonzero",
    fill: "#DDCCA2"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#DDCCA2",
    fillRule: "nonzero",
    opacity: 0.3,
    transform: "rotate(-87.902 396.804 131.735)",
    cx: 396.804,
    cy: 131.735,
    r: 19.999
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.4 222.5H205c-3.3 0-6-2.7-6-6v-26.9c0-3.3 2.7-6 6-6h46.4v38.9z",
    fill: "#DBE1EE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.6 99.3l5.3 19c1.8 6.5 3.4 13.1 4.8 19.8 2.6 13.3 4.2 26.8 4.7 40.4l.5 19.8.2 9.9.1 4.6c0 .6.2 1.3.5 1.8.3.6.8 1.1 1.4 1.4.3.2.6.3.9.4.2.1.3.1.5.1 0 0 .3 0 .5.1l.6.1 9.8 1.1 19.6 2.3c2.9.3 4.9 2.9 4.6 5.8-.3 2.8-2.8 4.8-5.6 4.6l-19.7-1.4-9.8-.7h-.6c-.2 0-.4 0-.7-.1-.6-.1-1.3-.2-1.9-.3-1.3-.3-2.5-.7-3.7-1.3-2.3-1.2-4.4-3-5.9-5.2s-2.5-4.7-2.7-7.4l-.1-.9v-.6l-.1-1.2-.2-2.5-.6-9.9-1.3-19.6c-.9-12.8-3-25.4-6-37.8-1.5-6.2-3.3-12.3-5.3-18.4l-6.1-18.8c-1.5-4.5 1-9.3 5.4-10.7 4.5-1.5 9.3 1 10.7 5.4.1-.1.2.1.2.2zM187.9 109.8l-2.8 9.5c-.9 3.1-1.8 6.1-2.5 9.2-1.6 6.1-2.9 12.4-3.9 18.6-1 6.3-1.8 12.6-2.3 18.9-.2 3.2-.4 6.4-.5 9.5l-.1 4.9-.1 5-.5 19.8-.1 5-.1 2.5v1c0 .4 0 .7-.1 1.1-.1.7-.2 1.5-.4 2.2-1.4 5.7-5.8 10.5-11.3 12.4l-2.1.6-1.1.2h-.8l-2.5.3-4.9.6-9.9 1.2-19.7 2.4c-3.5.4-6.7-2.1-7.2-5.6-.4-3.4 2-6.5 5.3-7.1l19.6-3.4 9.8-1.7 4.9-.8 2.4-.4.3-.1h.4c.1 0 .2-.1.3-.1.8-.3 1.3-1.1 1.4-1.9v-.3-.4l-.1-2.5-.1-5-.5-19.8-.1-5-.1-5c-.1-3.4 0-6.9.1-10.3.2-6.9.7-13.7 1.4-20.6.8-6.8 1.8-13.7 3.2-20.4.7-3.4 1.4-6.8 2.2-10.1l2.3-9.6c1.4-5.6 7-9.1 12.7-7.8 5.6 1.4 9.1 7 7.8 12.7-.2 0-.2.2-.3.3z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(139)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#g)",
    fillRule: "nonzero",
    opacity: 0.15,
    cx: 87.7,
    cy: 85.9,
    r: 75.5
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#649EF7",
    cx: 86.1,
    cy: 85.9,
    r: 85.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 90.1c20.1 0 38.9 3.3 52.9 9.3 11.8 5.1 18.8 11.6 18.8 17.5s-7 12.4-18.8 17.5c-14 6-32.8 9.3-52.9 9.3s-38.9-3.3-52.9-9.3c-11.8-5.1-18.8-11.6-18.8-17.5s7-12.4 18.8-17.5c14-6 32.8-9.3 52.9-9.3zm0-7c-43.4 0-78.7 15.1-78.7 33.8 0 18.7 35.2 33.8 78.7 33.8s78.7-15.1 78.7-33.8c0-18.7-35.3-33.8-78.7-33.8z",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.1 25.6C39.8 25.6 9.3 15.1.1.9c14.4 27.3 43 45.9 76 45.9 33.1 0 61.8-18.7 76.2-46.2-9.1 14.5-39.8 25-76.2 25z",
    fill: "#5469B2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBEEF7",
    fillRule: "nonzero",
    cx: 102.8,
    cy: 33.1,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EBEEF7",
    fillRule: "nonzero",
    cx: 61.3,
    cy: 33.1,
    r: 2.2
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#EBEEF7",
    strokeWidth: 2,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.2 33.2v1.9M75 31.3v5.8M80.8 29.3V39M86.7 31.3v5.8M92.5 33.2v1.9"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162 16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3 72.4c-3-26.3 12.9-51 38-59.3 11.4-3.8 23.8-3.8 35.2 0 24.1 8 39.8 31.2 38.2 56.6l-.2 2.8c-1.8 27.9-25 49.7-53 49.7h-5.2c-28-.1-51.2-21.9-53-49.8z",
    fill: "#D89868",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6 85.7H59.4c-10 0-18.1-8.1-18.1-18.1v-3.1c0-10 8.1-18.1 18.1-18.1h19.2c10 0 18.1 8.1 18.1 18.1v3.1c-.1 10.1-8.2 18.1-18.1 18.1z",
    fill: "#DDCCA2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 63.8h-9.1c-3.5 0-6.3-2.8-6.3-6.3v-1.1c0-3.5 2.8-6.3 6.3-6.3H70c3.5 0 6.3 2.8 6.3 6.3v1.1c0 3.4-2.8 6.3-6.3 6.3z",
    fill: "#243865",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#243865",
    fillRule: "nonzero",
    cx: 92.6,
    cy: 40.6,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#243865",
    fillRule: "nonzero",
    cx: 41.9,
    cy: 40.6,
    r: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 63.3l-1 6.6c0 .3-.3.5-.6.4-.2 0-.4-.2-.4-.4l-1-6.6c-.1-.8.4-1.6 1.3-1.7.8-.1 1.6.4 1.7 1.3v.4z",
    fill: "#243865",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2 77.5h5.4c6 0 10.9-4.9 10.9-10.9h0",
    stroke: "#243865",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D89868",
    fillRule: "nonzero",
    cx: 113.9,
    cy: 25.4,
    r: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1 26.4c2.4 4.5-19.1-.4-13.8-3.2 5.3-2.8 11.4-1.3 13.8 3.2z",
    fill: "#DDCCA2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#D89868",
    fillRule: "nonzero",
    cx: 12.5,
    cy: 25.4,
    r: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3 26c-2.4 4.5 19.1-.4 13.8-3.2-5.2-2.7-11.4-1.3-13.8 3.2z",
    fill: "#DDCCA2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7 17.3c-.9-4.2-2-3.9-2.8-8.1C62 5 62.2 5 61.3.8l.4.4c-2 1.1-4.5 1.4-6.2 2.7-1.7 1.4-2.6 3.7-4 5.4-1.4 1.7-3.2 3.1-4.3 5.1-1.1 1.9-1.6 4.1-2.3 6.2-.1.2.6.4.5.6",
    fill: "#D89868",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 21.7c-.9-4.2-.8-4.2-1.7-8.3-.9-4.1-2.1-3.9-3-8.1l.2-.7c-2 1.1-3.9 2.4-5.6 3.8-1.7 1.4-3.5 3-4.9 4.6-1.4 1.7-2.5 3.8-3.6 5.7-1.1 1.9-1.3 4.3-2 6.4-.1.2-.3.1-.4.3",
    fill: "#D89868",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#649EF7",
    fillRule: "nonzero",
    opacity: 0.2,
    d: "M280.4 164.3h5.9v5.9h-5.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#649EF7",
    fillRule: "nonzero",
    opacity: 0.2,
    cx: 284,
    cy: 177.7,
    r: 3.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167 197c.1-1.3.1-2.7.2-4",
    stroke: "#649EF7",
    strokeWidth: 4,
    opacity: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#649EF7",
    fillRule: "nonzero",
    cx: 167.2,
    cy: 183.1,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.2 193H275c-2.8 0-5 2.3-5 5h0c0 2.8-2.3 5-5 5h-11",
    stroke: "#DBE1EE",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.5 222.5h-40.4c-3.3 0-6-2.7-6-6v-26.9c0-3.3 2.7-6 6-6h40.4c3.3 0 6 2.7 6 6v26.9c0 3.3-2.6 6-6 6z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4B4784",
    fillRule: "nonzero",
    cx: 218.5,
    cy: 198.7,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 218.5,
    cy: 198.7,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#649EF7",
    fillRule: "nonzero",
    cx: 218.5,
    cy: 209.7,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#649EF7",
    fillRule: "nonzero",
    opacity: 0.2,
    d: "M230.9 195.1h6v6h-6zM240.9 195.1h6v6h-6zM240.9 205.1h6v6h-6zM230.9 205.1h6v6h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.9 159.2v38.4c0 3.1 2.5 5.5 5.5 5.5h6.1",
    stroke: "#FFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBear);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Bear.d927aa543aaf5d2b952744672f79e69d.svg";